<template>
  <div>
    <ListingLayout
      :is-loading="isLoading"
      :meta="meta"
      :headers="_headers"
      :items="chargerAvailability?.issues"
      per-page="100000"
      selected-product="cso"
      :product-options="productOptions"
      :filter-names="filterNames"
      search-label="search"
      show-date
      @filterOption="onFiltersChange"
    >
      <!-- add Filters -->
      <!-- <template #addFilters>
        <v-card v-if="authUser.isAdmin">

        </v-card>
      </template> -->

      <template #description>
        <v-row>
          <v-col cols="12">
            <availibility-cards
              :loading="isLoading"
              :items="chargerAvailability"
            />
          </v-col>
          <v-col
            cols="12"
            md="8"
          >
            <performance-trend
              :loading="isLoading"
              :items="chargerAvailability?.daily_trend"
            />
          </v-col>
          <v-col
            cols="12"
            md="4"
          >
            <down-time
              :loading="isLoading"
              :items="chargerAvailability?.downtime_breakdown"
            />
          </v-col>
        </v-row>
      </template>

      <!-- add Filters -->
      <template #moreFilters>
        <div>
          <refresh-button
            :is-loading="isLoading"
            @reload="fetchData"
          />
        </div>
      </template>
      <!-- Action Modals -->
      <template #actionModals>
        <div />
      </template>
      <!-- Action Modals -->
    </ListingLayout>
  </div>
</template>

<script>
import { ListingLayoutMixins } from "@/mixins/ListingLayoutMixins";
import { mapGetters } from "vuex";
export default {
  components: {
    ListingLayout: () => import("@/layouts/section/ListingLayout.vue"),
    refreshButton: () => import("@/components/base/RefreshButton.vue"),
    AvailibilityCards: () => import("./utils/AvailibilityCards.vue"),
    PerformanceTrend: () => import("./utils/PerformanceTrend.vue"),
    DownTime: () => import("./utils/DownTime.vue"),
  },
  mixins: [ListingLayoutMixins],

  data() {
    return {
      productOptions: [
        { id: "oem", value: "OEM" },
        { id: "cso", value: "CSO" },
      ],
      permissions: {
        view: "charge-stations.view",
        create: "charge-stations.create",
        edit: "charge-stations.edit",
        delete: "charge-stations.delete",
      },
      filters: {},
      subFilters: {},
    };
  },
  computed: {
    ...mapGetters({
      authUser: "getUser",
      isLoading: "csmsDashboard/getLoading",
      chargerAvailability: "csmsDashboard/getChargerAvailability",
      //
      // meta: "csmsChargeStations/getMeta",
      // list: "csmsChargeStations/getList",
    }),

    _headers() {
      const headers = [
        {
          text: "Connector ID",
          align: "left",
          sortable: false,
          value: "connector_id",
        },
        {
          text: this.$t("tenant_name"),
          align: "left",
          sortable: false,
          value: "tenant_name",
          showAdmin: true,
        },
        {
          text: "Station Name",
          align: "left",
          sortable: false,
          value: "station_name",
        },

        {
          text: "Issue",
          align: "left",
          sortable: false,
          value: "issue",
        },

        {
          text: "Total Time (Hrs)",
          align: "center",
          sortable: true,
          value: "total_time_hours",
        },
        {
          text: "Down Time (Hrs)",
          align: "center",
          sortable: true,
          value: "down_time_hours",
        },
        {
          text: this.$t("status"),
          align: "left",
          sortable: false,
          value: "status",
        },
        // ...(this.isView || this.isEdit || this.isDelete
        //   ? [
        //       {
        //         text: this.$t("actions"),
        //         align: "left",
        //         sortable: false,
        //         value: "actions",
        //       },
        //     ]
        //   : []),
      ];

      // computed headers for showing columns to role based
      return headers.filter(
        (header) =>
          header.showAdmin === undefined ||
          (header.showAdmin != undefined &&
            header.showAdmin === this.authUser.isAdmin)
      );
    },

    filterNames() {
      return ["locations", "charge_point"];
    },
  },
  watch: {
    options() {
      this.fetchData();
    },
  },
  mounted() {},
  beforeDestroy() {
    const params = {
      name: "availability_dashboard",
      filters: this.options,
    };
    this.$store.commit("redirect/SET_FILTERS", params);
  },
  methods: {
    async fetchData() {
      const params = {
        ...this.options,
        abort_signal: "availability_dashboard",
      };
      await this.$store.dispatch("csmsDashboard/chargerAvailability", params);
    },
  },
};
</script>
